import { Component, inject } from '@angular/core';
import { NavigationEnd, RouterModule, Router } from '@angular/router';
import { LayoutService } from './app/layout/service/layout.service';
import { LoginInativoDialogComponent } from './app/components/login-inativo-dialog/login-inativo-dialog.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, LoginInativoDialogComponent],
    template: `<router-outlet></router-outlet> <app-login-inativo-dialog></app-login-inativo-dialog>`
})
export class AppComponent {
    layoutService: LayoutService = inject(LayoutService);
    router: Router = inject(Router);

    ngOnInit() {
        this.themeSelected();
        this.monitorarHistoricoRotas();
    }

    themeSelected() {
        const theme = localStorage.getItem('theme');
        const isDark = theme === 'dark';

        this.layoutService.layoutConfig.update((state) => ({
            ...state,
            darkTheme: isDark,
            menuTheme: isDark ? 'dark' : 'light',
            topbarTheme: isDark ? 'dark' : 'light',
        }));

        if (isDark) {
            document.documentElement.classList.add('app-dark');
        } else {
            document.documentElement.classList.remove('app-dark');
        }
    }

    private monitorarHistoricoRotas() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.salvarUltimaRota(event.urlAfterRedirects);
                this.atualizarHistoricoMenus(event.urlAfterRedirects);
            }
        });
    }

    private salvarUltimaRota(url: string) {
        let historico = JSON.parse(localStorage.getItem('historicoRotas') || '[]');
        if (historico[0] === url) return;
        historico.unshift(url);
        historico = historico.slice(0, 5);
        localStorage.setItem('historicoRotas', JSON.stringify(historico));
    }

    private extrairItensMenu(menu: any[]): any[] {
        let itens: any[] = [];
        
        menu.forEach(item => {
            if (item.items && Array.isArray(item.items)) {
                itens = [...itens, ...this.extrairItensMenu(item.items)];
            } else if (item.routerLink) {
                itens.push({
                    label: item.label,
                    icon: item.icon,
                    routerLink: item.routerLink[0] 
                });
            }
        });
        
        return itens;
    }

    private atualizarHistoricoMenus(url: string) {
        try {
            const menuAtual = localStorage.getItem('user_menu');
            if (!menuAtual) return;

            const menu = JSON.parse(menuAtual);
            let historico = JSON.parse(localStorage.getItem('historicoMenusPassados') || '[]');
            
            const todosItens = this.extrairItensMenu(menu);
            
            const itemAtual = todosItens.find(item => 
                item.routerLink && url.startsWith(item.routerLink)
            );
            
            if (!itemAtual) return;

            const itemHistorico = {
                label: itemAtual.label,
                icon: itemAtual.icon,
                routerLink: itemAtual.routerLink
            };

            historico = historico.filter((i: any) => 
                i.routerLink !== itemHistorico.routerLink
            );

            historico.unshift(itemHistorico);
            
            historico = historico.slice(0, 5);
            
            localStorage.setItem('historicoMenusPassados', JSON.stringify(historico));
        } catch (error) {
            console.error('Erro ao atualizar histórico de menus:', error);
        }
    }
}
